<template>
  <div
    class="absolute"
    style="width: 20vw; left: 2rem; top: 37%;"
  >
    <div
      v-if="title"
      class="f3 pb4"
      :class="{
        'purple': brand === 'lh',
        'dark-gray': brand === 'lq'
      }"
      v-html="title"
    />
    <div class="relative">
      <div
        v-for="(item, i) in items"
        :key="'nav-' + i"
        class="relative mb4 ph2 pointer overflow-hidden"
        :class="{
          'purple': brand === 'lh',
          'dark-gray': brand === 'lq',
          'active': $route.path === item.route
        }"
        style="max-height: 1.6rem;"
        ref="mainContainer"
      >
        <div
          class="vertical-bar absolute"
          :class="{
            'bg-purple': brand === 'lh',
            'bg-dark-gray': brand === 'lq'
          }"
          style="width: 0.25rem; left: 1.2rem; z-index: -1; top: -1.4rem;"
        />
        <div
          class="flex items-center"
          @click="navigate(item.route, i); $store.commit('setSidebarNav', i);"
        >
          <div
            v-if="brand === 'lh'"
            class="ba bw2 br-100 mr3 b--purple"
            :class="{
              'bg-white': $route.path !== item.route,
              'bg-purple': $route.path === item.route || isChild(item.children, $route.path)
            }"
            style="width: 1.6rem; height: 1.6rem;"
          />
          <div
            v-if="brand === 'lq'"
            class="ba bw2 br-100 mr3 b--dark-gray"
            :class="{
              'bg-white': $route.path !== item.route,
              'bg-dark-gray': $route.path === item.route || isChild(item.children, $route.path),
            }"
            style="width: 1.6rem; height: 1.6rem;"
          />
          <div
            class="f4"
            :class="{
              'b': $route.path === item.route || isChild(item.children, $route.path)
            }"
            v-html="item.title"
          />
        </div>
        <transition-group tag="div">
          <div
            v-for="(child, j) in item.children"
            :key="'nav-child-' + j"
            class="pt3"
            style="margin-left: 0.7rem"
          >
            <div
              class="h2 pointer flex items-center"
              @click="$store.commit('setActiveTab', j)"
              :class="{
                'purple': brand === 'lh',
                'dark-gray': brand === 'lq',
              }"
            >
              <svg
                width="28"
                height="12"
                viewBox="0 0 28 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="padding-bottom: 0.5rem; margin-right: -1px;"
              >
                <path
                  class="sidebar-paths"
                  d="M2 0.5C2 11 12.5 10 28 10"
                  stroke="currentColor"
                  stroke-width="0.25rem"
                />
              </svg>

              <div
                class="sidebar-dots ba bw2 br-100 mr3"
                :class="{
                  'b--purple': brand === 'lh',
                  'b--dark-gray': brand === 'lq',
                  'bg-purple': activeChild === j && brand === 'lh',
                  'bg-dark-gray': activeChild === j && brand === 'lq',
                }"
                style="width: 1.5rem; height: 1.5rem"
              />
              <div
                class="sidebar-titles f4 lh-copy title"
                :class="{
                  'b': activeChild === j,
                  'purple': brand === 'lh',
                  'dark-gray': brand === 'lq'
                }"
                v-html="child.title"
              />
            </div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
gsap.registerPlugin(DrawSVGPlugin)
const find = require('lodash/find')

export default {
  name: 'NavSidebar',
  props: {
    brand: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      navLine: require('@/assets/img/nav-children-line.svg'),
      arrowIcon: require('@/assets/img/arrow-left-circle.svg')
    }
  },
  computed: {
    activeParent () {
      return this.$store.state.sidebarTab
    },
    activeChild () {
      return this.$store.state.activeTab
    }
  },
  mounted () {
    this.openTab(0)
  },
  methods: {
    isChild (haystack, needle) {
      if (find(haystack, ['route', needle])) {
        return true
      } else {
        return false
      }
    },
    navigate (route, index) {
      if (this.$route.path !== route) {
        const menu = this.$refs.mainContainer
        menu.forEach((item, i) => {
          if (item.classList.contains('active')) {
            this.closeTab(i, index)
          }
        })
        this.$router.push(route)
        setTimeout(() => {
          this.$store.commit('setActiveTab', 0)
        }, 500)
      }
    },
    resetTabs () {
      this.$refs.mainContainer.forEach((item, i) => {
        if (i !== 0) {
          this.closeTab(i, 0)
        }
      })
    },
    openTab (index) {
      if (this.$refs.mainContainer[index]) {
        const menu = this.$refs.mainContainer[index]
        const bar = menu.querySelector('.vertical-bar')
        const titles = menu.querySelectorAll('.sidebar-titles')
        const dots = menu.querySelectorAll('.sidebar-dots')
        const paths = menu.querySelectorAll('.sidebar-paths')
        const openTab = gsap.timeline({
          paused: true
        })
        openTab.fromTo(menu,
          {
            maxHeight: 1.6 + 'rem'
          },
          {
            maxHeight: 500 + 'px',
            delay: 0,
            duration: 0.5,
            ease: 'none'
          }
        )
        if (titles.length > 0) {
          openTab.fromTo(bar,
            {
              height: 0 + '%'
            },
            {
              height: 100 + '%',
              delay: -0.5,
              duration: (titles.length + 1) * 0.15,
              ease: 'none'
            }
          ).fromTo(paths,
            {
              drawSVG: '0 0%'
            },
            {
              duration: 0.15,
              drawSVG: '0% 100%',
              delay: -(dots.length * 0.15) + 0.15,
              stagger: 0.15
            }
          ).fromTo(dots,
            {
              scale: 0
            },
            {
              scale: 1,
              duration: 0.15,
              stagger: 0.15,
              delay: -(dots.length * 0.15) + 0.15,
              ease: 'back.out(1.7)'
            }
          ).fromTo(titles,
            {
              opacity: 0,
              x: -10 + 'px'
            },
            {
              duration: 0.15,
              opacity: 1,
              x: 0 + 'px',
              delay: -(dots.length * 0.15) + 0.15,
              stagger: 0.15
            }
          )
        }
        openTab.play()
      }
    },
    closeTab (i, nextIndex) {
      if (this.$refs.mainContainer[i]) {
        const menu = this.$refs.mainContainer[i]
        const bar = menu.querySelector('.vertical-bar')
        const titles = menu.querySelectorAll('.sidebar-titles')
        const dots = menu.querySelectorAll('.sidebar-dots')
        const paths = menu.querySelectorAll('.sidebar-paths')
        const closeTab = gsap.timeline({
          paused: true
        })
        if (paths.length > 0) {
          closeTab.to(titles,
            {
              duration: 0.2,
              opacity: 0,
              x: -10 + 'px'
            }
          ).to(dots,
            {
              scale: 0,
              duration: 0.5,
              delay: -(dots.length * 0.2) + 0.2,
              ease: 'back.out(1.7)'
            }
          ).to(paths,
            {
              duration: 0.5,
              drawSVG: '0% 0%',
              delay: -(dots.length * 0.2) + 0.2
            }
          ).to(bar,
            {
              height: 0 + '%',
              delay: -0.2,
              duration: 0.5,
              ease: 'none'
            }
          )
        }
        closeTab.to(menu, {
          maxHeight: 1.6 + 'rem',
          duration: 0.5,
          delay: -0.5,
          onComplete: this.nextAnime,
          onCompleteParams: [nextIndex]
        })
        closeTab.play()
      }
    },
    nextAnime (nextIndex) {
      this.openTab(nextIndex)
    }
  }
}
</script>
